import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-emoji-category-symbol",
  "use": "icon-emoji-category-symbol-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-emoji-category-symbol\">\n    <path fill=\"none\" d=\"M12 12L12 15\" stroke=\"#42526E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n    <circle fill=\"none\" cx=\"12\" cy=\"12\" r=\"7\" stroke=\"#42526E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n    <circle cx=\"12\" cy=\"9\" r=\"1\" fill=\"#42526E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol